import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles/styles.css";
import reportWebVitals from "./reportWebVitals";
import { CourseProvider } from "./context/CourseContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <CourseProvider>
      <App />
    </CourseProvider>
  </React.StrictMode>
);

// // uncomment this to upload data
// import React from "react";
// import ReactDOM from "react-dom/client";
// import "./index.css";
// import addData from "./addData";

// // Run the script
// addData();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
